const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
  AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI,
};

export default config;
